export default {
  title: "Konto",
  subtitle: "Verwalten Sie Ihre Kontoinformationen",
  description: "Verwalten Sie Ihre Kontoeinstellungen",
  profile: {
    title: "Profil",
    completeProfile: "Profil vervollständigen",
    defaultName: "Gast",
    noProfile: "Kein Profil",
    errors: {
      loadProfile: "Fehler beim Laden des Profils",
      saveProfile: "Fehler beim Speichern des Profils"
    },
    weddingInfo: {
      title: "Hochzeitsinformationen",
      partner1: "Partner 1",
      partner2: "Partner 2",
      date: "Datum",
      location: "Ort",
      expectedGuests: "Erwartete Gäste",
      notes: "Notizen"
    }
  },
  settings: {
    title: "Einstellungen",
    loadError: "Fehler beim Laden der Einstellungen",
    saveError: "Fehler beim Speichern der Einstellungen",
    saveSuccess: "Einstellungen erfolgreich gespeichert"
  },
  security: "Sicherheit",
  notifications: "Benachrichtigungen",
  profilePhoto: "Profilbild",
  changePhoto: "Foto ändern",
  photoRequirements: "JPG, PNG oder GIF, max. 2MB",
  deletePhoto: "Foto löschen",
  saveChanges: "Änderungen speichern",
  twoFactorAuth: "Zwei-Faktor-Authentifizierung",
  linkedAccounts: "Verknüpfte Konten",
  dataExport: "Datenexport",
  subscription: {
    title: "Abonnement",
    currentPlan: "Aktueller Plan",
    free: "Kostenlos",
    essential: "Essential",
    pro: "Pro",
    manage: "Abonnement verwalten",
    viewPlans: "Pläne anzeigen",
    upgrade: "Upgrade",
    eventsUsed: "Verwendete Veranstaltungen",
    limits: {
      maxGuests: "Max. Gäste",
      maxTasks: "Max. Aufgaben",
      maxVendors: "Max. Dienstleister",
      maxEvents: "Max. Veranstaltungen"
    },
    features: {
      unlimitedEvents: "Unbegrenzte Veranstaltungen",
      unlimitedGuests: "Unbegrenzte Gäste",
      export: "PDF & Excel Export",
      budget: "Budget & Analyse",
      seating: "Sitzplan",
      support: "Priorisierter Support"
    },
    plans: {
      free: {
        name: "Kostenlos"
      },
      essential: {
        name: "Essential"
      },
      premium: {
        name: "Premium"
      },
      pro: {
        name: "Pro"
      }
    }
  },
  limits: {
    title: "Limits",
    maxGuests: "Maximale Gäste",
    maxTasks: "Maximale Aufgaben",
    maxVendors: "Maximale Dienstleister",
    maxCollaborators: "Maximale Mitarbeiter"
  },
  form: {
    firstName: "Vorname",
    lastName: "Nachname",
    email: "E-Mail",
    phone: "Telefon",
    address: "Adresse",
    city: "Stadt",
    country: "Land",
    timezone: "Zeitzone",
    language: "Sprache",
    avatar: "Avatar"
  },
  actions: {
    save: "Speichern",
    cancel: "Abbrechen",
    edit: "Bearbeiten",
    delete: "Konto löschen",
    changePassword: "Passwort ändern",
    uploadAvatar: "Avatar hochladen"
  },
  messages: {
    profileUpdated: "Profil erfolgreich aktualisiert",
    passwordChanged: "Passwort erfolgreich geändert",
    avatarUploaded: "Avatar erfolgreich hochgeladen",
    accountDeleted: "Konto erfolgreich gelöscht",
    error: "Ein Fehler ist aufgetreten"
  },
  events: {
    yourEvents: "Ihre Veranstaltungen"
  },
  partners: {
    title: "Partnerinformationen",
    partner1: "Partner 1",
    partner2: "Partner 2",
    firstName: "Vorname",
    lastName: "Nachname",
    email: "E-Mail",
    save: "Speichern"
  },
  pageTitle: "Konto | WedBox",
  accountManagement: "Kontoverwaltung",
  chooseWhatToManage: "Wählen Sie, was Sie verwalten möchten",
  myProfile: "Mein Profil",
  personalPreferences: "Persönliche Präferenzen",
  managePersonalInfo: "Verwalten Sie Ihre persönlichen Informationen, Profilbild, Sprache und Benachrichtigungseinstellungen.",
  accessMyProfile: "Auf mein Profil zugreifen",
  eventSettings: "Veranstaltungseinstellungen",
  eventTypeSpecific: {
    wedding: {
      subtitle: "Spezifisch für Ihre Hochzeit",
      description: "Verwalten Sie Ihre Hochzeitsdetails, Partner, Datum, Mitarbeiter und Statistiken.",
      buttonText: "Hochzeitseinstellungen"
    },
    birthday: {
      subtitle: "Spezifisch für Ihren Geburtstag",
      description: "Verwalten Sie Ihre Geburtstagsdetails, Datum, Mitarbeiter und Statistiken.",
      buttonText: "Geburtstagseinstellungen"
    },
    "baby-shower": {
      subtitle: "Spezifisch für Ihre Babyparty",
      description: "Verwalten Sie Ihre Babyparty-Details, Datum, Mitarbeiter und Statistiken.",
      buttonText: "Babyparty-Einstellungen"
    },
    baptism: {
      subtitle: "Spezifisch für Ihre Taufe",
      description: "Verwalten Sie Ihre Taufdetails, Datum, Mitarbeiter und Statistiken.",
      buttonText: "Taufeinstellungen"
    },
    engagement: {
      subtitle: "Spezifisch für Ihre Verlobung",
      description: "Verwalten Sie Ihre Verlobungsdetails, Datum, Mitarbeiter und Statistiken.",
      buttonText: "Verlobungseinstellungen"
    },
    default: {
      subtitle: "Spezifisch für Ihre Veranstaltung",
      description: "Verwalten Sie Ihre Veranstaltungsdetails, Datum, Mitarbeiter und Statistiken.",
      buttonText: "Veranstaltungseinstellungen"
    }
  },
  improvedOrganization: "📋 Verbesserte Organisation",
  organizationNote: "Wir haben die persönlichen Einstellungen von den veranstaltungsspezifischen Einstellungen getrennt, um eine bessere Organisation zu gewährleisten. Ihre Benutzereinstellungen befinden sich jetzt in \"Mein Profil\", während alles, was Ihre Veranstaltung betrifft, in \"Veranstaltungseinstellungen\" zu finden ist.",
  subscriptionManagement: "Abonnementverwaltung",
  manageYourPlan: "Verwalten Sie Ihren Plan und verfolgen Sie Ihre Nutzung",
  displayName: "Anzeigename",
  phoneNumber: "Telefonnummer",
  yourFullName: "Ihr vollständiger Name",
  emailAddress: "E-Mail-Adresse",
  emailCannotBeModified: "E-Mail kann aus Sicherheitsgründen nicht geändert werden",
  personalInformation: "Persönliche Informationen",
  languageInterface: "Schnittstellensprache",
  notificationPreferences: "Benachrichtigungseinstellungen",
  emailNotifications: "E-Mail-Benachrichtigungen",
  receiveEmailNotifications: "E-Mail-Benachrichtigungen erhalten",
  pushNotifications: "Push-Benachrichtigungen",
  receiveBrowserNotifications: "Browser-Benachrichtigungen erhalten",
  deleteAccountWarning: "⚠️ Diese Aktion ist irreversibel. Alle Ihre Daten werden dauerhaft gelöscht.",
  permanentlyDeleteAccount: "Mein Konto dauerhaft löschen",
  languageChangedTo: "Sprache geändert zu {{language}}",
  error: "Fehler:",
  saveError: "Hier können Sie eine Fehlerbenachrichtigung hinzufügen",
  language: "Sprache",
  languageDescription: "Wählen Sie die Anzeigesprache der Anwendung",
  languageSelect: "Wählen Sie Ihre Sprache",
  weddingDetails: "Hochzeitsdetails",
  weddingDate: "Hochzeitsdatum",
  partnerInfo: "Partnerinformationen",
  partner1: "Partner 1",
  partner2: "Partner 2",
  firstName: "Vorname",
  lastName: "Nachname",
  accessManagement: "Zugriffsverwaltung",
  accessManagementDescription: "Verwalten Sie, wer auf Ihre Hochzeitsdaten zugreifen kann",
  manageCollaborators: "Mitarbeiter verwalten",
  loadError: "Fehler beim Laden der Einstellungen",
  saveSuccess: "Einstellungen erfolgreich gespeichert",
  noData: "Keine Daten verfügbar",
  tabs: {
    profile: "Profil",
    sharing: "Teilen",
    settings: "Einstellungen"
  },
  delete: {
    title: "Konto löschen",
    description: "Löschen Sie Ihr Konto und alle zugehörigen Daten dauerhaft",
    confirmTitle: "Sind Sie sicher?",
    confirmDescription: "Diese Aktion ist irreversibel. Alle Ihre Daten werden dauerhaft gelöscht.",
    confirmButton: "Konto löschen",
    gdprNotice: "Gemäß der DSGVO werden alle Ihre persönlichen Daten dauerhaft gelöscht."
  },
  deleteAccount: {
    title: "Konto löschen",
    description: "Löschen Sie Ihr Konto und alle Ihre Daten dauerhaft. Diese Aktion ist irreversibel.",
    warning: "Warnung: Diese Aktion ist irreversibel und löscht alle Ihre Daten dauerhaft.",
    confirm: "Ja, mein Konto löschen",
    confirmDescription: "Bestätigen Sie Ihr Passwort, um Ihr Konto zu löschen.",
    confirmFacebookDescription: "Sie sind mit Facebook angemeldet. Um das Löschen Ihres Kontos zu bestätigen, klicken Sie auf die Schaltfläche unten.",
    confirmGoogleDescription: "Sie sind mit Google angemeldet. Um das Löschen Ihres Kontos zu bestätigen, klicken Sie auf die Schaltfläche unten.",
    passwordLabel: "Passwort",
    reasonLabel: "Grund für das Löschen",
    feedbackLabel: "Zusätzliches Feedback",
    reasons: {
      select: "Wählen Sie einen Grund",
      notUseful: "Die App ist für mich nicht nützlich",
      tooComplex: "Die App ist zu komplex",
      foundAlternative: "Ich habe eine bessere Alternative gefunden",
      other: "Anderer Grund"
    },
    errors: {
      invalidPassword: "Falsches Passwort",
      reasonRequired: "Bitte wählen Sie einen Grund",
      popupClosed: "Das Bestätigungsfenster wurde geschlossen",
      authCancelled: "Authentifizierung abgebrochen",
      generic: "Ein Fehler ist aufgetreten",
      recentLogin: "Bitte melden Sie sich erneut an, um diese Aktion durchzuführen",
      wrongPassword: "Falsches Passwort"
    },
    success: "Konto erfolgreich gelöscht"
  },
  export: {
    title: "Daten exportieren",
    description: "Laden Sie alle Ihre Daten im JSON-Format herunter",
    button: "Daten herunterladen",
    loading: "Download wird vorbereitet...",
    gdprNotice: "Dieser Export enthält alle Ihre persönlichen Daten gemäß den DSGVO-Anforderungen."
  },
  errors: {
    deleteAccount: "Fehler beim Löschen des Kontos",
    exportData: "Fehler beim Exportieren der Daten"
  },
  collaborators: {
    title: "Mitarbeiter",
    description: "Verwalten Sie Personen, die Ihnen bei der Hochzeitsplanung helfen können",
    count: "{{count}} Mitarbeiter",
    invite: "Mitarbeiter einladen",
    inviteEmail: "E-Mail-Adresse",
    placeholder: "E-Mail-Adresse eingeben",
    role: "Rolle",
    roles: {
      admin: "Administrator",
      editor: "Editor",
      viewer: "Betrachter"
    },
    roleDescriptions: {
      admin: "Kann alles ändern und Mitarbeiter verwalten",
      editor: "Kann ausgewählte Abschnitte ändern",
      viewer: "Kann nur ausgewählte Abschnitte anzeigen"
    },
    rolesTitle: "Rollenverwaltung",
    accessTo: "Zugriff auf",
    accessToSections: "Zugriff auf Abschnitte",
    resourceTypes: {
      all: "Alles",
      tasks: "Aufgaben",
      guests: "Gäste",
      budget: "Budget",
      timeline: "Zeitplan",
      tasks_and_guests: "Aufgaben und Gäste"
    },
    status: {
      pending: "Ausstehend",
      accepted: "Akzeptiert",
      refused: "Abgelehnt",
      expired: "Abgelaufen"
    },
    lastActive: "Zuletzt aktiv",
    remove: "Mitarbeiter entfernen",
    modifyAccess: "Zugriff ändern",
    updateRoleError: "Fehler beim Aktualisieren der Rolle",
    inviteSuccess: "Einladung erfolgreich gesendet",
    inviteError: "Fehler beim Senden der Einladung",
    list: "Mitarbeiterliste",
    empty: "Noch keine Mitarbeiter"
  },
  sharing: {
    activeLinksTitle: "Aktive Freigabelinks",
    activeLinksDesc: "Diese Links ermöglichen den Zugriff auf Ihre Veranstaltung ohne Benutzerkonto.",
    accessTo: "Zugang zu"
  }
};
